import type { Logo as GQLLogo } from '../generated/checkout.graphql';
import * as CheckoutImageVariant from './CheckoutImageVariant';
import { take } from '../util/takePayload';

export type CheckoutVenueLogo = {
  variants: CheckoutImageVariant.CheckoutImageVariant[];
};

export const fromGql = (gqlLogo: GQLLogo): CheckoutVenueLogo => {
  return {
    ...(take<CheckoutVenueLogo>(
      gqlLogo,
    )),
    variants: gqlLogo.variants ? gqlLogo.variants.map(CheckoutImageVariant.fromGql) : [],
  };
};
